// extracted by mini-css-extract-plugin
module.exports = {"horizontal":"style__horizontal__7k3i2"};